import React from 'react';
import CardExportImport from './card_exportimport';

const TabHealthSettings = ({ records, loadHealthRecords }) => {
  return (
    <div className="bg-white p-4 rounded-2xl shadow flex-1">
      <h2 className="text-lg font-semibold mb-4">Health Settings</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <CardExportImport records={records} reload={loadHealthRecords} />
      </div>
    </div>
  );
};

export default TabHealthSettings;
